// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module__image___1di46","title":"styles-module__title___PATax","container":"styles-module__container___QF5WL"};